import React from 'react';
import { SimpleModalTW } from '../../../../../../tailwindComponents/modals/SimpleModalTW';
import { Confirmation } from './Confirmation';
import { useSelectAppointmentFromPathParam } from '../../../../../../utilities/order/scheduling/useSomeAppointmentFromParam';

export interface SigSyncConfirmationModalProps {
  show: boolean;
  onClose: () => void;
}

export const SigSyncConfirmationModal = ({ show, onClose }: SigSyncConfirmationModalProps) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  if (!appointmentFromPath) return null;
  return (
    <SimpleModalTW open={show} setOpen={onClose}>
      <Confirmation onClose={onClose} />
    </SimpleModalTW>
  );
};
